import React, { Component } from "react"
import PCHeader from "./PCHeader"
import MobileHeader from "./MoblieHeader"
import { mediumStyles } from "../../constants"
import { withStyles } from "@material-ui/core/styles"
import { Grid } from "@material-ui/core"

function Header({ classes }) {
  return (
    <>
      <Grid className={classes.pc}>
        <PCHeader />
      </Grid>
      <Grid className={classes.mobile}>
        <MobileHeader />
      </Grid>
    </>
  )
}

export default withStyles(mediumStyles)(Header)
